export const config = {
  // Proxy must be running on same server as this app, or origin allowed
  proxy:    'http://localhost/csv-test/proxy-pages.php', 
  entities: 'https://www.transparency.gov.au/entities-with-published-publications',
  reports:  'https://export.dart.masterdocs.com.au/vb4fRe6zFTXuqQvbsvmW8vHE/allReports.csv',
};